import createReactComponent from '../createReactComponent';
export default createReactComponent('text-align-right', 'TextAlignRight', [["path",{"d":"M4.5 6h15m-10 4h10m-15 4h15m-10 4h10","key":"svg-0"}]]);